module.exports = __webpack_public_path__ + "img/20201107_204108.bd5722bf.jpg";